import { render, staticRenderFns } from "./InfoLockButton.vue?vue&type=template&id=23adb07c&scoped=true&"
import script from "./InfoLockButton.vue?vue&type=script&lang=ts&"
export * from "./InfoLockButton.vue?vue&type=script&lang=ts&"
import style0 from "./InfoLockButton.vue?vue&type=style&index=0&id=23adb07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adb07c",
  null
  
)

export default component.exports